// extracted by mini-css-extract-plugin
export default {"gameOverView":"GameOverView_gameOverView__p4a9v","buttons":"GameOverView_buttons__VuJHV"};